const modal = {
    namespaced: true,

    state: {
        modals: {
            readings: false,
            postal: false,
            councilWebsite: false,
            markCouncilDone: false,
            energyBill: false,
        },
    },

    mutations: {
        OPEN_MODAL(state, payload) {
            state.modals[payload] = true
        },
        CLOSE_MODAL(state, payload) {
            state.modals[payload] = false
        },
    },

    actions: {
        // open modal
        openModal({ commit }, payload) {
            commit('OPEN_MODAL', payload)
        },
        // close modal
        closeModal({ commit }, payload) {
            commit('CLOSE_MODAL', payload)
        },
    }
}

export default modal;